import {
    FETCH_SUBSCRIPTIONS,
    SAVE_SUBSCRIPTION,
    DELETE_SUBSCRIPTION,
} from '../../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_SUBSCRIPTIONS:
            return action.payload;
        case SAVE_SUBSCRIPTION:
            return state.concat(action.payload);
        case DELETE_SUBSCRIPTION:
            return state.filter(sub => sub.id !== action.payload.subId);
        default:
            return state;
    }
};
